import { ModuleLocalization } from '@ocean/configs/dist/localization'
import { BASE_NAMESPACE } from 'config/localization/constants'
import en from './en'

export const namespace = `${BASE_NAMESPACE}_DISTANCE_COURSE_DETAILS`

export const localization: ModuleLocalization = { namespace, en }
